import {
  RefFeedbackTabComponent,
  RefPlannedChangesTabComponent,
  RefStakeholdersTabComponent
} from '@q9elements/ui-kit/refmodels';
import {ClassificationTabComponent} from '../components/classification-tab/classification-tab.component';
import {SystemInfoTabComponent} from '../components/system-info-tab/system-info-tab.component';

export enum InternalNodeSidebarSubTabs {
  StakeholdersTab = 'stakeholders_info',
  FeedbackTab = 'feedback_info',
  SystemInfoTab = 'system_info',
  PlannedChangesTab = 'planned_changes_info',
  ClassificationTab = 'classification_info'
}

export const internalNodeSidebarTabs = {
  [InternalNodeSidebarSubTabs.SystemInfoTab]: SystemInfoTabComponent,
  [InternalNodeSidebarSubTabs.StakeholdersTab]: RefStakeholdersTabComponent,
  [InternalNodeSidebarSubTabs.PlannedChangesTab]: RefPlannedChangesTabComponent,
  [InternalNodeSidebarSubTabs.FeedbackTab]: RefFeedbackTabComponent,
  [InternalNodeSidebarSubTabs.ClassificationTab]: ClassificationTabComponent
};
